import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { useEffect } from "react";

export default function useInitGoogleAuth() {
  useEffect(() => {
    if (
      process.env.NODE_ENV === "production" ||
      window.location.hostname === "localhost"
    )
      GoogleAuth.initialize({
        clientId:
          "792688012585-cbt0iqc3oucm587229dbks3v038cid90.apps.googleusercontent.com",
        scopes: ["email", "profile"],
        grantOfflineAccess: true,
      });
  }, []);
}
